const addToCartBtn = document.querySelector('.og-add-to-cart');
const stickyAddToCart = document.querySelector('.wt-product__add-to-cart_form-sticky');
const scrollToTopBtn = document.querySelector('.atc-sticky__scroll-to-top');

if (addToCartBtn && stickyAddToCart) {
  const mediaQuery = '(max-width: 900px)';
  const mediaQueryList = window.matchMedia(mediaQuery);

  let observer;

  // Create Observer
  function createObserver(isMobile) {
    if (observer) {
      observer.disconnect();
    }

    const pageHeader = document.querySelector('.header');
    const headerHeight = pageHeader ? pageHeader.offsetHeight : 0;

    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          stickyAddToCart.classList.remove('visible');
          return;
        }

        if (isMobile) {
          stickyAddToCart.classList.toggle(
            'visible',
            entry.boundingClientRect.top <= headerHeight
          );
        } else {
          stickyAddToCart.classList.add('visible');
        }
      });
    }, {
      threshold: 0.5,
      rootMargin: `-${headerHeight}px 0px 0px 0px`,
    });

    observer.observe(addToCartBtn);
  }

  // On load
  createObserver(mediaQueryList.matches);

  // Listen for breakpoint changes
  mediaQueryList.addEventListener('change', (event) => {
    createObserver(event.matches);
  });
}

// Scroll to top button
function scrollToTop() {
  scrollToTopBtn.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  });
}

if (scrollToTopBtn && stickyAddToCart) {
  scrollToTop();
}